import CopyIcon from '@/shared/assets/icons/copy.svg?react'
import { BaseDialog, BaseInput } from '@/shared/components'
import { PayoutIcon } from '@/shared/components/icons/PayoutIcon'
import { ItemLayout } from '@/shared/components/ItemLayout/ItemLayout'
import { formatterRubWithCurrency } from '@/shared/utils/formatters'

type Props = {
  modalAppeals: boolean
  setModalAppeals: (value: boolean) => void
}

export const AppealsDialog = ({ modalAppeals, setModalAppeals }: Props) => {
  return (
    <BaseDialog
      isVisible={modalAppeals}
      onClose={() => setModalAppeals(false)}
      onAction={() => {}}
      actionButtonName="Обновить данные"
      closeButtonName="Вернуться назад"
      iconTitle={
        <ItemLayout
          icon={<PayoutIcon status="green" className="w-[52px] h-[52px]" />}
          title={''}
          subtitle={'1 ч 12 м 15 сек'}
          titleClasses="text-[20px] !font-klein"
          subtitleClasses="!text-primary font-klein font-medium"
        />
      }
    >
      <div className="flex flex-col gap-1 pt-6 border-t-1 border-t-card-border dark:border-t-card-border-dark">
        <span>Cумма к оплате</span>
        <span className="font-klein font-medium text-[18px]">
          {formatterRubWithCurrency.format(0)}
        </span>
      </div>
      <div>
        <span className="text-text-secondary">Реквизиты для оплаты</span>
        <div className="flex flex-col gap-[10px]">
          <span>T-Банк</span>
          <div className="flex items-center gap-[10px]">
            <BaseInput className="grow" value="2200 0002 2020 0022" />
            <button onClick={() => console.log('cl')}>
              <CopyIcon className="w-6 h-6 text-primary" />
            </button>
          </div>
          <div className="flex items-center gap-[10px]">
            <BaseInput className="grow" value="Александр Иванович Ч." />
            <button onClick={() => console.log('cl')}>
              <CopyIcon className="w-6 h-6 text-primary" />
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <span className="text-text-secondary">Выписка от клиента</span>
        <span>Изображение.pdf</span>
        <span>12 KB 11 апреля 2024 г. в 14:38</span>
      </div>
      <div className="flex flex-col gap-4">
        <span>Приложите чек об оплате</span>
        <span>Изображение.pdf</span>
      </div>
    </BaseDialog>
  )
}
